import React, { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import ButtonWrapper from "../../../components/Button";
import FileUploader from "../../../reusableComponents/FileUploader2";
import InputWrapper from "../../../layout/inputWrapper";
import KmlFileUploader from "../../../../TCPForms/reusableComponents/KmlFileUploader";
const Documents = ({ formData, handleTabChange, t, applicationData }) => {
  console.log("isApprovedLayoutFromDocs", formData, applicationData);

  const { documents } = useSelector((state) => state.formMT);
  const defaultValues = {
    ...formData,
    descriptionOfLand: {
      ...formData.descriptionOfLand,
      googleMapCoordinates: [...(applicationData?.descriptionOfLand?.googleMapCoordinates || [])],
      googleMapLocation: applicationData?.descriptionOfLand?.googleMapLocation || "",
    },
    documents: documents,
  };

  const { handleSubmit, control, reset, setValue } = useForm({ defaultValues });
  console.log("formDataFromFARDOcs", documents);
  const [showError, setShowError] = useState(false);
  const validateFiles = () => {
    const uploadedDocs = new Set(documents?.map((doc) => doc.documentType)); // Using Set for faster lookups
    const requiredDocs =
      applicationData?.descriptionOfLand?.schemeType === "Scheme"
        ? ["landOwnershipDoc", "completeDrawingFile", "kmlFile", "mutationDocument"]
        : ["landOwnershipDoc", "khataKhasraDocs", "kmlFile", "completeDrawingFile"];

    return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  };
  const handleFormSubmit = (data) => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  const onSubmit = (data) => {
    // data = {
    //   ...data,
    //   documents: [...formData?.documents, ...documents],
    // };
    console.log("dataFromDocuments", data);

    handleTabChange(2, data);
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("LABEL_UPLOAD_DOCUMENTS")}</h2>
          </div>
          {!(applicationData?.descriptionOfLand?.schemeType === "Scheme") && (
            <Container className="formInputContainer" fluid>
              <Row>
                <Col>
                  <FileUploader
                    showError={showError}
                    isMandatory
                    // hasLabel={false}
                    label={t("Land Ownership Document")}
                    control={control}
                    name="landOwnershipDoc"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                    tab={4}
                    maxFiles={1}
                  />
                </Col>

                <Col>
                  <FileUploader
                    showError={showError}
                    isMandatory
                    // hasLabel={false}
                    label={t("LABEL_RELEVANT_DOCS_RELATED_TO_KHATA_KHASRA")}
                    control={control}
                    name="khataKhasraDocs"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                    tab={4}
                    maxFiles={1}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <KmlFileUploader
                    name={"kmlFile"}
                    label={"KML File"}
                    isMandatory
                    validationMsg={"(.kml file only and Max file Size 10 MB)"}
                    required
                    tab={1}
                    showError={showError}
                    // control={control}
                    maxFiles={1}
                  />
                </Col>
                <Col>
                  <FileUploader
                    isMandatory
                    // hasLabel={false}
                    label="Complete drawing including Location/Site plan, Key plan, Site Superimposed on Master plan"
                    control={control}
                    name="completeDrawingFile"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                    tab={4}
                    showError={showError}
                    maxFiles={1}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <FileUploader
                    // hasLabel={false}
                    label="Site Superimposed on Sajra Plan"
                    control={control}
                    name="sajraPlan"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    tab={4}
                    showError={showError}
                    maxFiles={1}
                  />
                </Col>
                <Col></Col>
              </Row>
            </Container>
          )}
          {applicationData?.descriptionOfLand?.schemeType === "Scheme" && (
            <Container className="formInputContainer" fluid>
              <Row>
                <Col>
                  <FileUploader
                    isMandatory
                    // hasLabel={false}
                    label="Complete drawing including Location/Site plan, Key plan, Site Superimposed on Master plan"
                    control={control}
                    name="completeDrawingFile"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                    tab={4}
                    showError={showError}
                    maxFiles={1}
                  />
                </Col>
                <Col>
                  <FileUploader
                    showError={showError}
                    isMandatory
                    // hasLabel={false}
                    label={t("Land Ownership Document")}
                    control={control}
                    name="landOwnershipDoc"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                    tab={4}
                    maxFiles={1}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <KmlFileUploader
                    name={"kmlFile"}
                    label={"KML File"}
                    isMandatory
                    validationMsg={"(.kml file only and Max file Size 10 MB)"}
                    required
                    tab={1}
                    showError={showError}
                    // control={control}
                    maxFiles={1}
                  />
                </Col>
                <Col>
                  <FileUploader
                    showError={showError}
                    isMandatory
                    // hasLabel={false}
                    label={t("Mutation Document")}
                    control={control}
                    name="mutationDocument"
                    validationMsg="(pdf file only and Max file Size 30 MB)"
                    required
                    tab={4}
                    maxFiles={1}
                  />
                </Col>
              </Row>
            </Container>
          )}
          <Container className="formInputContainer" fluid>
            <Row>
              <Col>
                <InputWrapper
                  label="Latitude"
                  control={control}
                  placeholder="Enter Latitude"
                  name="descriptionOfLand.googleMapCoordinates.[0].latitude"
                  type="decimal"
                  mandatory
                  required
                  disabled={applicationData?.descriptionOfLand?.googleMapCoordinates?.[0]?.latitude}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={10}
                />
              </Col>
              <Col>
                <InputWrapper
                  label="Longitude"
                  control={control}
                  placeholder="Enter Longitude"
                  name="descriptionOfLand.googleMapCoordinates.[0].longitude"
                  type="decimal"
                  mandatory
                  disabled={applicationData?.descriptionOfLand?.googleMapCoordinates?.[0]?.longitude}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={10}
                />
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <InputWrapper
                  label="Land Address"
                  control={control}
                  placeholder="Enter Land Address"
                  // disabled={}
                  name="descriptionOfLand.googleMapLocation"
                  type="textInput"
                  maxLength={150}
                />
              </Col>

              <Col>
                {/* <KmlFileUploader
                  name={"kmlFile"}
                  label={"KML File"}
                  isMandatory
                  validationMsg={"(.kml file only and Max file Size 10 MB)"}
                  required
                  tab={1}
                  showError={showError}
                  control={control}
                  maxFiles={1}
                /> */}
            {/* </Col> */}
            {/* </Row>  */}
          </Container>
          <div className="footerContainer2">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                onClick={() => handleTabChange(0)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
              />
            </div>
          </div>
        </div>
      </form>
    </section>
  );
};

export default Documents;
